import { RootModelAction } from '../actions';
import { mergeWebsocketEntities, transformObjects } from '../store.helpers';
import { OnlineOfflineStatus } from './online-offline.model';
import {
  transformOnlineOfflineStatusChange,
  transformOnlineOfflineStatusFetch,
} from './online-offline.transformers';

declare module '../root.model' {
  interface RootModel {
    onlineOffline: OnlineOfflineStatus;
  }
}

export function onlineOfflineReducer(
  state = {},
  action: RootModelAction<'onlineOffline'>,
) {
  switch (action.type) {
    case 'WS_MESSAGE':
      if (
        action.payload.parent_type === 'onlineoffline' &&
        action.payload.type === 'statusget'
      ) {
        const { toUserId, data } = action.payload;
        return mergeWebsocketEntities<'onlineOffline'>(
          state,
          transformObjects(
            Object.entries(data),
            transformOnlineOfflineStatusFetch,
          ),
          { path: ['onlineOffline', toUserId, undefined] },
        );
      } else if (
        action.payload.parent_type === 'onlineoffline' &&
        action.payload.type === 'statuschange'
      ) {
        const { data, toUserId } = action.payload;
        return mergeWebsocketEntities<'onlineOffline'>(
          state,
          transformObjects([data], transformOnlineOfflineStatusChange),
          { path: ['onlineOffline', toUserId, undefined] },
        );
      }

      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/online-offline/online-offline.reducer.ts